module.exports = __webpack_public_path__ + "static/STG20_Mobile_480_Module5_Drink2_Elderfashioned-a8d5ee06a52564469036ed444efa9a2e.png";